module.exports = __webpack_public_path__ + "static/media/add session.a2ce4803.svg";